import { Logger } from './logging'

export const moduleName = 'hawtio-core'
export const log = Logger.get(moduleName)
